import CreateAction from '~/components/Actions/CreateAction';
import Signup from '~/components/Signup';
import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { Publication } from '~/interfaces/publication';
import type { HomePageLoaderData } from '~/routes';
import normalizeFontType from '~/utils/normalizeFontType';

import Section from './Section';

interface Props {
  publication: Publication;
  bgColor: string;
  textColor: string;
  fontFamily: string;
  placeholderText?: string;
  ctaText?: string;
  isNewWebBuilder?: boolean;
}

const SignupWidgetSection = ({
  publication,
  bgColor,
  textColor,
  fontFamily,
  placeholderText,
  ctaText,
  isNewWebBuilder = false,
}: Props) => {
  const { signupWidgetConfigs } = useTypedLoaderData<HomePageLoaderData>();

  return (
    <Section text="Signup" isNewWebBuilder={isNewWebBuilder}>
      <div className="flex flex-wrap gap-2">
        {isNewWebBuilder ? (
          <Signup signupStyles={signupWidgetConfigs} />
        ) : (
          <CreateAction
            publication={publication}
            fontFamily={normalizeFontType(fontFamily)}
            placeholderText={placeholderText}
            cta={ctaText}
            textColor={textColor}
            backgroundColor={bgColor}
          />
        )}
      </div>
    </Section>
  );
};

export default SignupWidgetSection;
